import Vue from 'vue'
import Vuex from 'vuex'
import { login, loginPhone, getUserInfo, accountLogin } from '@/api/login'
import { getCartList } from '@/api/order'
import { getAdList, collectThings, messageGetmessage } from '@/api/user'
import { configData } from '@/api/index'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : getToken(),
    username: localStorage.getItem('username') ? localStorage.getItem('username') : '',
    usericon: localStorage.getItem('usericon') ? localStorage.getItem('usericon') : '',
    userid: localStorage.getItem('userid') ? localStorage.getItem('userid') : '',
    shopName: localStorage.getItem('shopName') ? localStorage.getItem('shopName') : '',
    email: localStorage.getItem('email') ? localStorage.getItem('email') : '',
    cartnum: localStorage.getItem('cartnum') ? localStorage.getItem('cartnum') : '0',
    messagenum: localStorage.getItem('messagenum') ? localStorage.getItem('messagenum') : '0',
    purchasedGoods: localStorage.getItem('purchasedGoods') ? localStorage.getItem('purchasedGoods') : '',
    typeList: localStorage.getItem('typeList') ? localStorage.getItem('typeList') : '',
    searchType: localStorage.getItem('searchType') ? localStorage.getItem('searchType') : '1',
    mallLogo: localStorage.getItem('mallLogo') || null,
    mallName: localStorage.getItem('mallName') || null,
    mallIcp: localStorage.getItem('mallIcp') || null,
    isRegister: localStorage.getItem('isRegister') || null,
    companyName: localStorage.getItem('companyName') || null,
    mallTitle: localStorage.getItem('mallTitle') || null,
    mallDesc: localStorage.getItem('mallDesc') || null,
    mallKeywords: localStorage.getItem('mallKeywords') || null,
    statisticsCode: localStorage.getItem('statisticsCode') || null,
    visitsNum: localStorage.getItem('visitsNum') ? localStorage.getItem('visitsNum') : JSON.stringify({ num: 0, time: new Date().getTime() })
  },
  mutations: {
    SET_TOKEN(state, token) { // 存储token
      state.token = token
      localStorage.setItem('token', token)
      setToken(token)
    },
    SET_USERICON(state, usericon) { // 存储用户名
      state.usericon = usericon
      localStorage.setItem('usericon', usericon)
    },
    SET_NAME(state, username) { // 存储用户名
      state.username = username
      localStorage.setItem('username', username)
    },
    SET_USERID(state, userid) { // 存储用户名
      state.userid = userid
      localStorage.setItem('userid', userid)
    },
    SET_PURCHASED_GOODS(state, purchasedGoods) { // 传给确认订单页面的参数
      state.purchasedGoods = purchasedGoods
      localStorage.setItem('purchasedGoods', purchasedGoods)
    },
    SET_SEARCH_TYPE(state, searchType) { // 设置搜索条件
      state.searchType = searchType
      localStorage.setItem('searchType', searchType)
    },
    setshopName(state, shopName) { // 存储店铺名
      state.shopName = shopName
      localStorage.setItem('shopName', shopName)
    },
    delshopName(state) { // 删除店铺名
      state.shopName = ''
      localStorage.removeItem('shopName')
    },
    setEmail(state, email) { // 存储用户名
      state.email = email
      localStorage.setItem('email', email)
    },
    delEmail(state) { // 删除用户名
      state.email = ''
      localStorage.removeItem('email')
    },
    SET_CART_NUM(state, num) { // 购物车数量
      state.cartnum = num
      localStorage.setItem('cartnum', num)
    },
    DEL_CART_NUM(state) { // 购物车数量
      state.cartnum = 0
      localStorage.removeItem('cartnum')
    },
    SET_MESSAGE_NUM(state, num) { // 消息未读数量
      state.messagenum = num
      localStorage.setItem('messagenum', num)
    },
    DEL_MESSAGE_NUM(state) { // 消息未读数量
      state.messagenum = 0
      localStorage.removeItem('messagenum')
    },
    setGoodsTypeList(state, list) { // 传给确认订单页面的参数
      state.typeList = list
      localStorage.setItem('typeList', list)
    },
    SET_MALL_LOGO(state, logo) { // 商城logo
      state.mallLogo = logo
      localStorage.setItem('mallLogo', logo)
    },
    SET_MALL_NAME(state, mallName) { // 商城名称
      state.mallName = mallName
      localStorage.setItem('mallName', mallName)
    },
    SET_MALL_REGISTER(state, isRegister) { // 是否注册
      state.isRegister = isRegister
      localStorage.setItem('isRegister', isRegister)
    },
    SET_STATISTICS_CODE(state,statisticsCode){//统计代码
      state.statisticsCode = statisticsCode
      localStorage.setItem("statisticsCode",statisticsCode)
    },
    SET_MALL_ICP(state, mallIcp) { // icp名称
      state.mallIcp = mallIcp
      localStorage.setItem('mallIcp', mallIcp)
    },
    SET_COMPANYNAME(state, companyName) { // 公司名称
      state.companyName = companyName
      localStorage.setItem('companyName', companyName)
    },
    SET_MALL_KEYWORDS(state, mallKeywords) { // 商城关键词
      state.mallKeywords = mallKeywords
      localStorage.setItem('mallKeywords', mallKeywords)
    },
    SET_MALL_DESC(state, mallDesc) { // 商城描述
      state.mallDesc = mallDesc
      localStorage.setItem('mallDesc', mallDesc)
    },
    SET_MALL_TITLE(state, mallTitle) { // 商城描述
      state.mallTitle = mallTitle
      localStorage.setItem('mallTitle', mallTitle)
    },
    SET_VISITS_NUM(state, num) { // 访问次数
      state.visitsNum = num
      localStorage.setItem('visitsNum', num)
    },
  },
  actions: {
    MallLogo({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallLogo', tips: '商城Logo' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_LOGO', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    CompanyName({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_companyName', tips: '公司名称' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_COMPANYNAME', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    MallName({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallName', tips: '商城名称' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_NAME', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    isRegister({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallRegister', tips: '关闭注册（0是  1否）' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_REGISTER', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    MallIcp({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'J_mallIcp', tips: 'ICP证书或ICP备案证书号' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_ICP', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    MallTitle({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallTitle', tips: '商城标题' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_TITLE', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    MallDesc({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallDescribe', tips: '商城描述' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_DESC', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    MallKeywords({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'P_mallKeywords', tips: '商城关键字' }).then(res => {
          if (res.data && res.data.name) {
            commit('SET_MALL_KEYWORDS', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })

    },
    //统计代码
    StatisticsCode({ commit }) {
      return new Promise((resolve, reject) => {
        configData({ key: 'J_statisticsCode', tips: '页面统计代码' }).then(res => {
         /* console.log("统计代码2"+res.data.name);*/
          if (res.data && res.data.name) {
            commit('SET_STATISTICS_CODE', res.data.name)
            resolve(res.data.name)
          } else {
            reject(res)
          }
        }).catch(err => {
        /*  console.log("统计代码3"+err);*/
          reject(err)
        })
      })
    },
    // 账号登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机号登录
    LoginPhone({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginPhone(userInfo).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 账号信息登录
    AccountLogin({ commit }, params) {
      return new Promise((resolve, reject) => {
        accountLogin(params).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(res => {
          const data = res.data
          commit('SET_NAME', data.username)
          commit('SET_USERID', data.id)
          commit('SET_USERICON', data.icon)
          // debugger
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_USERICON', '')
        localStorage.removeItem('token')
        resolve()
      })
    },
    // 查询购物车列表
    GetCartList({ commit }) {
      return new Promise((resolve, reject) => {
        getCartList().then(res => {
          var total_quantity = 0
          if (!res.data.length) {
            commit('DEL_CART_NUM')
            resolve(res)
            return
          }
          for (var i = 0; i < res.data.length; i++) {
            var product = res.data[i].cartItemList
            for (var j = 0; j < product.length; j++) {
              total_quantity += product[j].quantity
            }
          }
          commit('SET_CART_NUM', total_quantity)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询消息未读列表
    GetMessageNum({ commit }) {
      return new Promise((resolve, reject) => {
        messageGetmessage({ hasRead: 2, pageNum: 1, pageSize: 20 }).then(res => {
          if (!res.data.length) {
            commit('DEL_MESSAGE_NUM')
            resolve(res)
            return
          }
          commit('SET_MESSAGE_NUM', res.data.total)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取广告列表
    GetAdList({ commit }, content) {
      return new Promise((resolve, reject) => {
        getAdList(content).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 收藏功能
    CollectThings({ commit }, content) {
      return new Promise((resolve, reject) => {
        collectThings(content).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
})

export default store
